import React from 'react';
import { Box, Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { Skeleton, SkeletonText } from '@shared/components/Skeleton';
import { useAccommodationsConsoleConfig } from '@apps/accommodations/AccommodationsConsoleConfigContext';

export const FiltersPanelSkeleton = () => {
  const config = useAccommodationsConsoleConfig();

  return (
    <>
      <SkeletonText
        rows={1}
        width="100%"
        skeletonHeight={48}
      />

      {config.filtersPanel.shouldShowJoyTravelBenefitsFilter && (
        <Box>
          <SkeletonText
            rows={1}
            width={'85%'}
            skeletonHeight={20}
            marginBottom={pxToRem(20)}
          />
          <Flex
            flexDirection="column"
            gap={6}
          >
            <Flex
              alignItems="center"
              gap={3}
            >
              <Skeleton
                width={20}
                height={20}
                borderRadius={2}
              />
              <Flex
                alignItems="center"
                gap={2}
              >
                <SkeletonText
                  rows={1}
                  width={200}
                  skeletonHeight={20}
                />
              </Flex>
            </Flex>
          </Flex>
        </Box>
      )}

      {/* Guest Rating Section */}
      <Box>
        <SkeletonText
          rows={1}
          width="70%"
          skeletonHeight={20}
          marginBottom={pxToRem(20)}
        />
        <Flex
          flexDirection="column"
          gap={6}
        >
          {[1, 2, 3, 4].map(i => (
            <Flex
              key={i}
              alignItems="center"
              gap={3}
            >
              <Skeleton
                width={20}
                height={20}
                borderRadius={2}
              />
              <SkeletonText
                rows={1}
                width="80%"
                skeletonHeight={20}
              />
            </Flex>
          ))}
        </Flex>
      </Box>

      {/* Price Range Section */}
      <PriceFilterSkeleton />

      {/* Star Rating Section */}
      <Box>
        <SkeletonText
          rows={1}
          width="65%"
          skeletonHeight={20}
          marginBottom={3}
        />
        <SkeletonText
          rows={1}
          width="100%"
          skeletonHeight={32}
          marginBottom={pxToRem(24)}
        />
        <Flex
          flexDirection="column"
          gap={6}
        >
          {[1, 2, 3, 4, 5].map(i => (
            <Flex
              key={i}
              alignItems="center"
              gap={3}
            >
              <Skeleton
                width={20}
                height={20}
                borderRadius={2}
              />
              <Flex
                alignItems="center"
                gap={2}
              >
                <SkeletonText
                  rows={1}
                  width={60}
                  skeletonHeight={20}
                />
                <Skeleton
                  width={80}
                  height={20}
                />
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Box>

      {/* Facilities Section */}
      <Box>
        <SkeletonText
          rows={1}
          width="55%"
          skeletonHeight={20}
          marginBottom={pxToRem(20)}
        />
        <Flex
          flexDirection="column"
          gap={6}
        >
          {[1, 2, 3, 4, 5, 6, 7, 8].map(i => (
            <Flex
              key={i}
              alignItems="center"
              gap={3}
            >
              <Skeleton
                width={20}
                height={20}
                borderRadius={2}
              />
              <Flex
                alignItems="center"
                gap={2}
              >
                <SkeletonText
                  rows={1}
                  width={100}
                  skeletonHeight={20}
                />
                <SkeletonText
                  rows={1}
                  width={30}
                  skeletonHeight={20}
                  color="mono10"
                />
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Box>
    </>
  );
};

export const PriceFilterSkeleton = () => {
  return (
    <Box maxWidth={{ _: pxToRem(222), sm: 'full' }}>
      <SkeletonText
        rows={1}
        width="60%"
        skeletonHeight={20}
        marginBottom={3}
      />
      <SkeletonText
        rows={1}
        width="100%"
        skeletonHeight={16}
        marginBottom={pxToRem(24)}
      />
      <Flex
        gap={3}
        marginTop={7}
      >
        <Box>
          <SkeletonText
            rows={1}
            width="60%"
            skeletonHeight={12}
            marginBottom={2}
          />
          <Skeleton
            width={100}
            height={48}
          />
        </Box>
        <Box marginTop={pxToRem(24)}>-</Box>
        <Box>
          <SkeletonText
            rows={1}
            width="60%"
            skeletonHeight={12}
            marginBottom={2}
          />
          <Skeleton
            width={100}
            height={48}
          />
        </Box>
      </Flex>
      <Box>
        <SkeletonText
          rows={1}
          width="100%"
          skeletonHeight={pxToRem(52)}
        />
      </Box>
    </Box>
  );
};
